import { RecordBucket } from "@scayla/api-client-fetch";
import type { VNode } from "vue";

/** The router reuses one instance across the routes that render a view; another list must start fresh, as after a reload. */
export function tableColumnViewKey(view: VNode): string {
  return `${view.props?.moduleId ?? ""}:${view.props?.bucket ?? RecordBucket.REGULAR}`;
}
